import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { TColors, UIHeading1 } from '@cian/ui-kit';
import cn from 'clsx';
import * as React from 'react';

import { Card } from './Card';
import * as styles from './styles.css';
import { trackEstimHistoryShow } from '../../analytics';
import { TEstimationHistoryPage } from '../../types/redux/estimationHistory';

export interface IPrevEstimationsProps {
  textColor?: TColors;
  showMore?: React.ReactNode;
  estimationHistory: TEstimationHistoryPage[];
  onEstimationDelete(id: number, url: string): void;
  onRedirectToReportClick(url: string): void;
  deleteInProgressId?: number;
  cardsCount?: number;
}

export const PrevEstimations: React.VFC<IPrevEstimationsProps> = ({
  showMore,
  textColor,
  estimationHistory,
  onEstimationDelete,
  onRedirectToReportClick,
  deleteInProgressId,
}) => {
  return (
    <ActionAfterViewObserver callback={trackEstimHistoryShow} callbackDelay={1500} wrapper={false}>
      <div
        className={cn(
          styles['prev_estimations'],
          styles['container'],
          showMore && styles['prev_estimations_with_more'],
        )}
        data-name="estimations_history"
      >
        <UIHeading1 color={textColor}>Уже оценивали</UIHeading1>
        <div className={styles['content']}>
          {estimationHistory.map(page => {
            return page.estimationHistory.map(estimation => (
              <Card
                key={estimation.estimationId}
                estimation={estimation}
                onEstimationDelete={() => onEstimationDelete(estimation.estimationId, estimation.url)}
                isDeleting={deleteInProgressId === estimation.estimationId}
                testId={estimation.estimationId}
                onRedirectToReportClick={onRedirectToReportClick}
              />
            ));
          })}
        </div>
        {showMore && <div className={styles['show_more']}>{showMore}</div>}
      </div>
    </ActionAfterViewObserver>
  );
};
